<!-- 任务3 -->
<template>
    <div>
      <div class="course_Task3">
        <el-row style="border: 1px solid #D3D3D3;margin: 0 20px 20px 20px;padding: 0 20px 20px 20px;min-height: calc(100vh - 280px);">
          <template v-if="examType == 2">
            <p style="background-color: rgb(239, 242, 247);margin: 0 -20px;color: #2789E2;padding: 20px;">
              任务得分：10 分
            </p>
          </template>
          <p class="fontB"><i class="el-icon-document-remove icon_"></i>任务名称：</p>
          <p style="min-height: 21px;">{{taskInfo.taskTitle}}</p>
          <p class="fontB"><i class="el-icon-s-data icon_" style="color: #8a39c2;"></i>任务分值：</p>
          <p style="min-height: 21px;">{{taskInfo.taskScore}}分</p>
          <p class="fontB"><i class="el-icon-document-copy icon_"></i>考核内容：</p>
          <el-row class="aljj">
            <p>请同学们完成理论测评题目</p>
          </el-row>
          <p class="fontB"><i class="el-icon-edit-outline icon_" style="color: #2eb68e;"></i>考核任务：</p>
          <el-row>
            <el-col :span="12">
              <el-table
                border
                ref="table"
                show-summary
                :summary-method="getSummaries"
                :span-method="arraySpanMethod"
                :data="tableData"
                style="width: calc(100% - 20px);">
                <el-table-column prop="questionTypeName" header-align="center" align="center" label="题型">
                  <template slot-scope="scope">{{$retQuestionType(scope.row.questionType)}}</template>
                </el-table-column>
                <el-table-column prop="questionNum" header-align="center" align="center" label="选题量"> </el-table-column>
                <el-table-column prop="questionScore" header-align="center" align="center" label="分值">
                  <!-- <template slot-scope="scope">
                    <el-input v-model="scope.row.questionScore" @change="changeInfo(scope.row,scope.$index)"  placeholder="请输入分值"></el-input>
                  </template> -->
                </el-table-column>
                <el-table-column prop="questionTotal" header-align="center" align="center" label="合计">
                </el-table-column>
              </el-table>
              <el-row class="tc m10" v-if="false">
                <el-button type="primary" @click="seeQuestion">查看题目</el-button>
              </el-row>
            </el-col>
          </el-row>
        </el-row>
      </div>
    </div>
</template>
<script>

export default {
  name: 'Task3',
  props: {
    examType: { //考试类型 1：考试 2：查看成绩
      type: String,
      default: function(){
        return 1;
      }
    },
    taskId: { //任务ID
      type: String,
      default: function(){
        return "";
      }
    },
    courseId: { //课程ID
      type: String,
      default: function(){
        return "";
      }
    },
  },
  data() {
    return {
      tableData: [],
      taskInfo:{} //任务详情
    }
  },
  created() {
    this.getInfo();
  },
  mounted() {

  },
  methods: {
    getInfo(){ //获取详情
      this.$get("/api/teacherOpenCourseHandsOnSimulationTasks/getInfo.do",{taskId:this.taskId}).then((ret) =>{
        if(ret.code == 0){
          this.taskInfo = ret.data;
          this.tableData = ret.data.handsOnTaskProblemVo;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getSummaries(param) { //自定义合计行信息
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index == 0) {
          sums[index] = '得分';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }
      });
      return sums;
    },
    arraySpanMethod() { //合并合计行
      this.$nextTick(() => {
        if (this.$refs.table.$el) {
          let current = this.$refs.table.$el
              .querySelector(".el-table__footer-wrapper")
              .querySelector(".el-table__footer");
          let cell = current.rows[0].cells;
          cell[2].style.display = "none";
          cell[1].style.display = "none";
          cell[0].colSpan = "3";
        }
      })
    },
    seeQuestion(){ //查看试卷
      this.$router.push({name:'TExercises',query:{type:3,id:this.taskId,courseId:this.courseId}});
    }
  }
};
</script>
<style  lang="less">
  .course_Task3{
    .icon_{
      color: #2789E2;margin-right: 10px;
    }
    .has-gutter{
      th{
        border-color:#E5E5E5;
        background-color: #EFF2F7;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Teacher/components/PracticalTraining/Task3.vue